<template>
  <div class="delivery-holder">
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="buttons is-right">
          <button class="button is-primary" @click="openReportModal()">
            Relatório de entrega
          </button>
          <button class="button is-primary" @click="openCreateEditModal()">
            Nova entrega
          </button>
          <button class="button is-primary" @click="printDeliveryList()">
            Lista de entrega
          </button>
        </div>
      </div>
      <print-deliverable-list style="display: none;"></print-deliverable-list>
      <div class="column is-12" v-if="deliveries.length">
        <div v-for="delivery in deliveries" :key="delivery.id" class="section">
          <div class="columns is-multiline is-variable">
            <div class="column is-6">
              <h2 class="subtitle has-text-left has-text-weight-bold">
                {{ delivery.deliveryDate || delivery.date | moment("DD/MM/YYYY hh:mm") }}
              </h2>
            </div>
            <div class="column is-6 has-text-right">
              <div class="buttons is-right">
                <button
                  class="button is-danger"
                  @click="remove(delivery)"
                >
                  Remover
                </button>
                <button
                  class="button is-primary"
                  @click="printDelivery(delivery)"
                >
                  Imprimir
                </button>
                <button
                  class="button is-primary"
                  @click="openCreateEditModal(delivery)"
                >
                  Editar
                </button>
              </div>
            </div>
          </div>

          <div class="table-holder">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th>Endereço</th>
                  <th>Pets</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="customer in delivery.deliveryCustomers"
                  :key="customer.id"
                >
                  <td>
                    {{ customer.customerName }}
                  </td>
                  <td>
                    <div>
                      {{ customer.address.street }} -
                      {{ customer.address.number }},
                      {{ customer.address.neighborhood }}
                    </div>
                  </td>
                  <td>
                    <div v-for="pet in customer.pets" :key="pet.id">
                      <span
                        ><strong>{{ pet.pet.name }}</strong></span
                      >
                      <ul v-if="pet.deliveryProducts.length">
                        <li
                          v-for="product in pet.deliveryProducts"
                          :key="product.id"
                        >
                          ({{ product.receipt }} - {{ product.quantity }}x
                          {{ product.packageSize }}g)
                        </li>
                      </ul>
                      <span v-else> (Nenhum produto enviado)</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <paginate
          v-model="currentPage"
          :page-count="totalPages"
          :page-range="3"
          :click-handler="getData"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'ml-pagination pagination-sm'"
          :prev-class="'page-item'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :page-class="'page-item'"
        >
        </paginate>

        <print-delivery style="display: none;"></print-delivery>
      </div>
      <div class="column is-12" v-else>
        <div class="no-items-to-show-msg">
          Nenhuma entrega foi encontrada.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import CreateEditDeliveryModal from "../components/delivery/CreateEditDeliveryModal";
import NotificationsWrapper from "../helpers/NotificationsWrapper";
import PrintDelivery from "../components/delivery/PrintDelivery";
import { EventBus } from "../helpers/EventBus";
import { HTTP } from "../services/HttpServices";
import PrintDeliverableList from "../components/delivery/PrintDeliverableList";
import DeliveriesByCustomerIdAndPeriodComponent from "@/components/delivery/DeliveriesByCustomerIdAndPeriodComponent";
export default {
  name: "Deliveries",
  components: { PrintDeliverableList, PrintDelivery },
  data: () => ({
    currentPage: 1,
    searchText: ""
  }),
  computed: {
    ...mapState({
      deliveries: state => state.delivery.deliveries,
      isLoadingData: state => state.delivery.loading,
      totalPages: state => state.delivery.totalPages
    })
  },
  methods: {
    ...mapActions({
      getDeliveries: "delivery/getDeliveries",
      getPackings: "packing/getPackings",
      createDelivery: "delivery/createDelivery",
      removeDelivery: "delivery/removeDelivery"
    }),
    ...mapMutations({
      resetFilters: "delivery/resetFilters",
      setDriverFilters: "delivery/setQueryFilters",
      setPage: "delivery/setPage"
    }),
    async printDeliveryList() {
      let resp = await HTTP.get(`/pets?enabled=true&size=500000`);
      EventBus.$emit("print:deliverableList", resp.data.content);
    },
    generateDeliveries() {
      this.createDelivery()
        .then(() => {
          NotificationsWrapper.success("Entregas geradas com sucesso!");
        })
        .catch(() => {
          NotificationsWrapper.error(
            "Houve um erro ao tentar gerar as entregas. Tente novamente."
          );
        })
        .finally(() => {
          this.getDeliveries();
        });
    },
    openCreateEditModal(delivery) {
      this.$modal.show(
        CreateEditDeliveryModal,
        { deliveryParam: Object.assign({}, delivery) },
        { width: "900px", height: "auto", adaptive: true, scrollable: true, clickToClose: false },
        {
          closed: () => {
            this.getDeliveries();
          }
        }
      );
    },
    openReportModal() {
      this.$modal.show(
        DeliveriesByCustomerIdAndPeriodComponent,
        {},
        {
          width: "900px",
          height: "auto",
          adaptive: true,
          scrollable: true,
          clickToClose: false
        },
        {
          closed: () => {
            this.getDeliveries();
          }
        }
      );
    },
    getData(pageNum) {
      const page = pageNum - 1;
      this.currentPage = pageNum;
      this.setPage(page);
      this.getDeliveries();
    },
    remove(delivery) {
      let date = this.$moment(delivery.date).format('MM/DD/YYYY - HH:MM');
      this.$modal.show("dialog", {
        title: "Aviso de exclusão!",
        text: `Você deseja excluir a entrega ${date}?`,
        buttons: [
          {
            title: "Excluir",
            class: "vue-dialog-button error",
            handler: () => {
              this.removeDelivery(delivery.id)
                .then(() => {
                  NotificationsWrapper.success("Entrega excluída com sucesso!");
                  this.$modal.hide("dialog");
                  this.getDeliveries();
                })
                .catch(() => {
                  NotificationsWrapper.error(
                    "Não foi possível remover a entrega!"
                  );
                });
            }
          },
          {
            title: "Cancelar", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.,
            handler: () => {
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    printDelivery(delivery) {
      EventBus.$emit("print:delivery", delivery);
    }
  },
  created() {
    this.resetFilters();
    this.getDeliveries();
    this.getPackings();
    this.$store.commit("setSelectedViewTitle", "Entregas");
  }
};
</script>

<style lang="scss" scoped></style>
